import {
  BuildingOfficeIcon,
  CheckCircleIcon,
  LockClosedIcon
} from "@interstate/components/Icons";
import {isClientEntityOperational} from "@common-core/coat-operational-hierarchy-appsync-model";
import {InterstateToken} from "../../../../../lib/interstate";
import {BadgeMetadata} from "../../../../../badges";
import {CreatePlanNode} from "../../view-model";

export const reviewNodeBadgeMetadata = (
  token: InterstateToken,
  node: CreatePlanNode
): BadgeMetadata => {
  const operational = isClientEntityOperational(node.source);
  return {
    labelKey: operational
      ? "create-operational-hierarchy.plan-states.operational"
      : "create-operational-hierarchy.plan-states.creating",
    variant: operational ? "transparent" : node.selected ? "success" : "info",
    startIcon: operational ? (
      <CheckCircleIcon color={token("sem.color.on-surface.success.muted")} />
    ) : node.selected ? (
      <BuildingOfficeIcon />
    ) : (
      <LockClosedIcon />
    )
  };
};
